// Entorno Desarrollo
export const environment = {
  production: false,
  apiUrl: 'https://fichajes-api-dev.azurewebsites.net/api',
  appUrl: 'https://fichajes-dev.techme.es/',
  logLevel: 'debug',
  appTitle: 'DEV - Fichajes'
};
